import React from 'react';
import Button from './button';
import './eventcard.css'
import calendar from '../assets/calendar.svg';
import location from '../assets/location.svg';
import ticket from '../assets/ticket.svg';

const Eventcard = (props) => {
  return ( 
    <div className={props.cardstyle}>
      <div className='event_card_image' style={{ backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.34) 100%), url(${props.cardimg})` }}>
        <div className='event_card_top'>
          <div className='event_card_tag'>{props.cardcategory}</div>
          {props.cardlimit && <div className='event_card_limit'>{props.cardlimit}</div>}
        </div>
        {props.cardbadge && <div className='event_card_badge'>{props.cardbadge}</div>}
      </div>
      <div className='event_card_body'>
        <div className='event_card_title'>{props.cardtitle}</div>
        <div className='event_card_meta'>
          <img src={calendar} alt="" />
          <div>{props.carddate}</div>
        </div>
        <div className='event_card_meta'>
          <img src={location} alt="" />
          <div>{props.cardlocation}</div>
        </div>
        <Button btnstyle={props.buttonstyle} btntext={props.buttontext} btnimg={ticket} />
      </div>
    </div>
   );
}
 
export default Eventcard;
